import { render } from "./ProposalActionArgumentRatedControls.vue?vue&type=template&id=54d9aa39&scoped=true"
import script from "./ProposalActionArgumentRatedControls.vue?vue&type=script&lang=js"
export * from "./ProposalActionArgumentRatedControls.vue?vue&type=script&lang=js"

import "./ProposalActionArgumentRatedControls.vue?vue&type=style&index=0&id=54d9aa39&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d9aa39"]])

export default __exports__